import { ref } from 'vue';
import { useField } from 'vee-validate';


export default {
  __name: 'Terms',
  setup(__props, { expose }) {
  expose();

const select = ref(false);

const {
    setValue: setPrivacyValue,
    value: privacyValue,
    errorMessage: privacyMessage,
} = useField('privacy');
const {
    setValue: setAgreementOneValue,
    value: agreementOneValue,
    errorMessage: agreementOneMessage,
} = useField('agreement_one');
const {
    setValue: setAgreementTwoValue,
    value: agreementTwoValue,
    errorMessage: agreementTwoMessage,
} = useField('agreement_two');
const {
    setValue: setAgreementThreeValue,
    value: agreementThreeValue,
    errorMessage: agreementThreeMessage,
} = useField('agreement_three');

const selectAll = () => {
    select.value = !select.value;

    if (select.value) {
        setPrivacyValue(true);
        setAgreementOneValue(true);
        setAgreementTwoValue(true);
        setAgreementThreeValue(true);
    } else {
        setPrivacyValue(false);
        setAgreementOneValue(false);
        setAgreementTwoValue(false);
        setAgreementThreeValue(false);
    }
};

const __returned__ = { select, setPrivacyValue, privacyValue, privacyMessage, setAgreementOneValue, agreementOneValue, agreementOneMessage, setAgreementTwoValue, agreementTwoValue, agreementTwoMessage, setAgreementThreeValue, agreementThreeValue, agreementThreeMessage, selectAll, ref, get useField() { return useField } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}